import { useCallback, useState } from "react";

interface EditorState {
  code?: string;
  isJavaScriptMode: boolean;
  validationError: string | null;
}

export const useEditorStore = () => {
  const [needValidation, setNeedValidation] = useState(false);
  const [state, setState] = useState<EditorState>({
    code: undefined,
    isJavaScriptMode: false,
    validationError: null,
  });
  const setCode = useCallback(
    (code?: string) => {
      setState(state => {
        return {
          ...state,
          code,
        };
      });
    },
    [setState],
  );
  const setValidationError = (error: string | null) => {
    setState(state => {
      return {
        ...state,
        validationError: error,
      };
    });
  };

  const toggleLanguageMode = () => {
    setState(state => {
      return {
        ...state,
        isJavaScriptMode: !state.isJavaScriptMode,
      };
    });
  };

  return {
    code: state.code,
    setCode,
    setValidationError,
    toggleLanguageMode,
    isJavaScriptMode: state.isJavaScriptMode,
    validationError: state.validationError,
    needValidation,
    setNeedValidation,
  };
};
